export default "__VITE_ASSET__DtLrXm9l__"